import { useTranslation } from "react-i18next";
import { Lead } from "../../models/Lead";
import { ConfirmationModal } from "../ConfirmationModal";
import { TrashIcon, XMarkIcon } from "@heroicons/react/24/outline";

interface Props {
    info: {
        show: boolean;
        lead?: Lead;
    };
    onClose: () => void;
    deleteLead: (lead: Lead) => void
}

export const DeleteLeadModal: React.FC<Props> = ({
    info,
    onClose,
    deleteLead
}) => {

    const { t } = useTranslation();

    const onDeleteLead = () => {
        deleteLead(info.lead!)
        onClose();
    };

    return(
        <ConfirmationModal 
            label={t("DELETE_LEAD")}
            isDeleteConfirm={true}
            isOpen={info.show}
            onClose={onClose}
            cancelButton={{ label: t("CLOSE"), icon: <XMarkIcon />, onClick: onClose, }}
            saveButton={{ label: t("DELETE"), icon: <TrashIcon />, onClick: onDeleteLead }}
        >
            <div className='w-full flex flex-wrap items-center justify-center'>
                <label className="text-lg font-semibold py-4 px-2 text-center">
                    {t('DELETE_LEAD_MESSAGE')}
                </label>
            </div>
        </ConfirmationModal>
    )
}